var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8485 8.58659L15.7313 9.58033L12.7394 12.948L10.7224 10.6776C10.6078 10.5484 10.4523 10.4757 10.2901 10.4757C10.128 10.4757 9.97244 10.5484 9.8579 10.6776L6.17933 14.8251C5.94022 15.0942 5.94022 15.529 6.17933 15.7981C6.41844 16.0673 6.80469 16.0673 7.04379 15.7981L10.2871 12.1406L12.3041 14.411C12.5433 14.6802 12.9295 14.6802 13.1686 14.411L16.5958 10.5603L17.4787 11.554C17.6687 11.768 17.9998 11.6161 17.9998 11.3125V8.34505C18.0059 8.15182 17.871 8 17.6994 8H15.0692C14.7933 8 14.6584 8.37265 14.8485 8.58659V8.58659Z",
    fill: "#157FFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48595 2 2 6.48595 2 12C2 17.514 6.48595 22 12 22C17.514 22 22 17.514 22 12C22 6.48595 17.514 2 12 2ZM12 20.5714C7.27373 20.5714 3.42857 16.7263 3.42857 12C3.42857 7.27373 7.27373 3.42857 12 3.42857C16.7263 3.42857 20.5714 7.27373 20.5714 12C20.5714 16.7263 16.7263 20.5714 12 20.5714Z",
    fill: "#157FFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIconBlue);
export default __webpack_public_path__ + "static/media/pending_icon_blue.89e65f115419e7facc6e514f998ed137.svg";
export { ForwardRef as ReactComponent };